import {
  faTag,
  faMapMarkerAlt,
  faRoad,
  faHashtag,
  faInfoCircle,
  faBuilding,
  faCity,
  faGlobe,
  faFlag,
  faEnvelope,
  faPhoneAlt,
  faUser,
  faVoicemail,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../utils/factory/createField";

export const addressFields = [
  {
    section: "Dados do Endereço",
    fields: [
      createField({
        id: "address.alias",
        label: "Apelido",
        type: "text",
        placeholder: "Digite o apelido",
        fullWidth: false,
        icon: faTag,
      }),
      createField({
        id: "address.zip",
        label: "CEP",
        type: "text",
        placeholder: "Digite o CEP",
        mask: "99999-999",
        fullWidth: false,
        icon: faMapMarkerAlt,
      }),
      createField({
        id: "address.street",
        label: "Rua",
        type: "text",
        placeholder: "Digite a rua",
        fullWidth: false,
        icon: faRoad,
      }),
      createField({
        id: "address.number",
        label: "Número",
        type: "text",
        placeholder: "Digite o número",
        fullWidth: false,
        icon: faHashtag,
      }),
      createField({
        id: "address.district",
        label: "Bairro",
        type: "text",
        placeholder: "Digite o bairro",
        fullWidth: false,
        icon: faBuilding,
      }),
      createField({
        id: "address.city",
        label: "Cidade",
        type: "text",
        placeholder: "Digite a cidade",
        fullWidth: false,
        icon: faCity,
      }),
      createField({
        id: "address.state",
        label: "Estado",
        type: "text",
        placeholder: "Digite o estado",
        fullWidth: false,
        icon: faFlag,
      }),
      createField({
        id: "address.country",
        label: "País",
        type: "text",
        placeholder: "Digite o país",
        icon: faGlobe,
      }),
      createField({
        id: "address.details",
        label: "Detalhes",
        type: "textarea",
        placeholder: "Digite os detalhes",
        fullWidth: true,
        icon: faInfoCircle,
      }),
    ],
  },
  {
    section: "Dados do Contato",
    fields: [
      createField({
        id: "address.contact_name",
        label: "Apelido",
        type: "text",
        placeholder: "Digite o apelido",
        fullWidth: false,
        icon: faTag,
      }),
      createField({
        id: "address.contact_phone",
        label: "Telefone",
        type: "text",
        placeholder: "Digite o telefone",
        mask: "(99) 99999-9999",
        fullWidth: false,
        icon: faPhoneAlt,
      }),
      createField({
        id: "address.contact_email",
        label: "Email",
        type: "email",
        placeholder: "Digite o email",
        fullWidth: true,
        icon: faEnvelope,
      }),
    ],
  },
];

export const editAddressFields = [
  {
    section: "Dados do Endereço",
    fields: [
      createField({
        id: "address.alias",
        label: "Apelido",
        type: "text",
        placeholder: "Digite o apelido",
        fullWidth: false,
        icon: faTag,
      }),
      createField({
        id: "address.zip",
        label: "CEP",
        type: "text",
        placeholder: "Digite o CEP",
        mask: "99999-999",
        fullWidth: false,
        icon: faMapMarkerAlt,
      }),
      createField({
        id: "address.street",
        label: "Rua",
        type: "text",
        placeholder: "Digite a rua",
        fullWidth: false,
        icon: faRoad,
      }),
      createField({
        id: "address.number",
        label: "Número",
        type: "text",
        placeholder: "Digite o número",
        fullWidth: false,
        icon: faHashtag,
      }),
      createField({
        id: "address.details",
        label: "Detalhes",
        type: "text",
        placeholder: "Digite os detalhes",
        fullWidth: false,
        icon: faInfoCircle,
      }),
      createField({
        id: "address.district",
        label: "Bairro",
        type: "text",
        placeholder: "Digite o bairro",
        fullWidth: false,
        icon: faBuilding,
      }),
      createField({
        id: "address.city",
        label: "Cidade",
        type: "text",
        placeholder: "Digite a cidade",
        fullWidth: false,
        icon: faCity,
      }),
      createField({
        id: "address.state",
        label: "Estado",
        type: "text",
        placeholder: "Digite o estado",
        fullWidth: false,
        icon: faFlag,
      }),
      createField({
        id: "address.country",
        label: "País",
        type: "text",
        placeholder: "Digite o país",
        fullWidth: true,
        icon: faGlobe,
      }),
    ],
  },
  {
    section: "Dados do Contato",
    fields: [
      createField({
        id: "address.contact_name",
        label: "Apelido",
        type: "text",
        placeholder: "Digite o apelido",
        fullWidth: false,
        icon: faTag,
      }),
      createField({
        id: "address.contact_phone",
        label: "Telefone",
        type: "text",
        placeholder: "Digite o telefone",
        mask: "(99) 99999-9999",
        fullWidth: false,
        icon: faPhoneAlt,
      }),
      createField({
        id: "address.contact_email",
        label: "Email",
        type: "email",
        placeholder: "Digite o email",
        fullWidth: true,
        icon: faEnvelope,
      }),
    ],
  },
];

export const detailsAddressFields = [
  {
    section: "Dados do Endereço",
    fields: [
      createField({
        id: "alias",
        label: "Apelido",
        type: "text",
        placeholder: "Digite o apelido",
        fullWidth: false,
        icon: faTag,
        disabled: true,
      }),
      createField({
        id: "zip",
        label: "CEP",
        type: "text",
        placeholder: "Digite o CEP",
        fullWidth: false,
        icon: faMapMarkerAlt,
        disabled: true,
      }),
      createField({
        id: "street",
        label: "Rua",
        type: "text",
        placeholder: "Digite a rua",
        fullWidth: false,
        icon: faRoad,
        disabled: true,
      }),
      createField({
        id: "number",
        label: "Número",
        type: "text",
        placeholder: "Digite o número",
        fullWidth: false,
        icon: faHashtag,
        disabled: true,
      }),
      createField({
        id: "details",
        label: "Detalhes",
        type: "text",
        placeholder: "Digite os detalhes",
        fullWidth: false,
        icon: faInfoCircle,
        disabled: true,
      }),
      createField({
        id: "district",
        label: "Bairro",
        type: "text",
        placeholder: "Digite o bairro",
        fullWidth: false,
        icon: faBuilding,
        disabled: true,
      }),
      createField({
        id: "city",
        label: "Cidade",
        type: "text",
        placeholder: "Digite a cidade",
        fullWidth: false,
        icon: faCity,
        disabled: true,
      }),
      createField({
        id: "state",
        label: "Estado",
        type: "text",
        placeholder: "Digite o estado",
        fullWidth: false,
        icon: faFlag,
        disabled: true,
      }),
      createField({
        id: "country",
        label: "País",
        type: "text",
        placeholder: "Digite o país",
        fullWidth: true,
        icon: faGlobe,
        disabled: true,
      }),
      createField({
        id: "contact_name",
        label: "Contato",
        type: "text",
        placeholder: "Digite o contato",
        fullWidth: false,
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: "contact_phone",
        label: "Telefone",
        type: "text",
        placeholder: "Digite o telefone",
        fullWidth: false,
        icon: faPhoneAlt,
        disabled: true,
      }),
      createField({
        id: "contact_email",
        label: "Email",
        type: "text",
        placeholder: "Digite o e-mail",
        fullWidth: true,
        icon: faVoicemail,
        disabled: true,
      }),
    ],
  },
];
